import React, { Component } from 'react'
import { Input, Card, Button, List, Checkbox, DatePicker } from 'antd'
import PropTypes from 'prop-types'

import './filter.css'

export const dataBanks = [
  'Bank BCA',
  'Bank Mandiri',
  'Bank BNI',
  'Bank BRI',
  'Bank Mandiri Syariah ',
  'Bank Permata',
]

class Filter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: this.props.data || dataBanks,
      originalData: this.props.data || dataBanks,
      filter: [],
    }
  }

  search = (value) => {
    this.setState({
      ...this.state,
      filter: [],
      data: value
        ? this.state.originalData.filter(x =>
          x.toLowerCase().includes(value.toLowerCase()))
        : this.state.originalData,
    })
  }

  checkAll = () => {
    this.setState({ ...this.state, filter: this.state.data })
  }

  checkChange = (checkedValues) => {
    this.setState({ ...this.state, filter: checkedValues })
  }

  clear = () => {
    this.setState({ ...this.state, filter: [] })
  }

  timeOk = value => value

  filter = () => {
    const { field } = this.props
    this.props.filterMethod({
      field,
      value: this.state.filter.map(x => x.replace('Bank ', '').toLowerCase().split(' ').join('')),
    })
  }

  render() {
    const { data, filter } = this.state
    const { search } = this.props
    return (
      <Card className="app-filter">
        {this.props.sort && (
          <div>
            <Button className="app-filter_sort">Sort A - Z</Button>
            <Button className="app-filter_sort">Sort Z - A</Button>
          </div>
        )}
        {search && (
          <Input.Search
            className="app-filter_search"
            enterButton
            onSearch={this.search}
          />
        )}
        {this.props.type === 'default' && (
          <div>
            <div>
              <Button
                className="app-filter_search-action"
                onClick={this.checkAll}
              >
                Select All
              </Button>
              <Button className="app-filter_search-action" onClick={this.clear}>
                Clear
              </Button>
            </div>
            <div className="app-filter_list">
              <Checkbox.Group
                className="app-filter_list-checkbox-group"
                onChange={this.checkChange}
                value={filter}
              >
                <List
                  itemLayout="horizontal"
                  dataSource={data}
                  renderItem={item => (
                    <List.Item>
                      <Checkbox value={item} />
                      <div className="app-filter_list-item">{item}</div>
                    </List.Item>
                  )}
                />
              </Checkbox.Group>
            </div>
          </div>
        )}
        {this.props.type === 'time' && (
          <div>
            <DatePicker.RangePicker
              className="block app-filter_timepicker"
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              placeholder={['Start Time', 'End Time']}
              onOk={this.timeOk}
            />
          </div>
        )}
        <Button
          className="app-filter_filter-btn"
          type="primary"
          onClick={this.filter}
        >
          Filter
        </Button>
      </Card>
    )
  }
}

Filter.defaultProps = {
  sort: false,
  search: false,
  type: 'default',
  data: [],
}

Filter.propTypes = {
  field: PropTypes.string.isRequired,
  filterMethod: PropTypes.func.isRequired,
  type: PropTypes.string,
  search: PropTypes.bool,
  data: PropTypes.array,
  sort: PropTypes.bool,
}

export default Filter



// WEBPACK FOOTER //
// src/components/filter/index.js